import { createContext, useContext } from 'react';
export const LocaleContext = createContext({
    locale: null,
    changeLocale: null,
    loaded: true,
});
export const LocaleContextProvider = LocaleContext.Provider;
export const useLocaleContext = () => useContext(LocaleContext);
